import {
  Box,
  TextField,
  Button,
  Grid,
} from "@mui/material";
import PageTitle from "../Layout/PageTitle";
import APIAxios from "../../Api/APIAxios";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { GetAPI } from "../Backend/GetAPI";
import { PostFileAPI } from "../Backend/PostFileAPI";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";



const RelatoriosImprimir = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  const { id } = useParams();
  const apiAxios = APIAxios();

  const [formData, setFormData] = useState([]);

  const navigate = useNavigate();

  // BUSCA DADOS DO FABRICANTE
  useEffect(() => {
    const fetchData = async () => {

      setLoading(true);
      const response = await GetAPI(apiAxios, `/relat/param/${id}`);

      setLoading(false);

      if (response.success) {
        setFormData(response.data);
      } else {
        setAvisoErro(response.errorMessage || "Erro ao carregar fabricante.");
      }
    };
    fetchData();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setFormData((prev) =>
      prev.map((r) => (r.nome === name ? { ...r, valor: value } : r))
    );

  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    const payload = (formData ?? []).map((r) => ({
      nome: r.nome ?? "",
      tipo: r.tipo ?? "",
      valor: r.valor == null ? "" : String(r.valor),
    }));

    const response = await PostFileAPI(apiAxios, `/relat/${id}`, "", payload);

    setLoading(false);

    if (response.success) {
      setAvisoSucesso("Relatório gerado com sucesso.");
    } else {
      setAvisoErro(response.errorMessage || "Erro ao atualizar parâmetros.");
    }
  };

  const handleVoltar = () => {
    navigate("/relatorios");
  };

  const handleDateChange = (nome, novaData) => {
    const valor = novaData ? dayjs(novaData).format("DD/MM/YYYY") : "";

    setFormData((prev) =>
      prev.map((r) => (r.nome === nome ? { ...r, valor } : r))
    );
  };

  return (
    <Box>
      {/***************************************** AVISOS **********************************/}
      <PageTitle
        caption="Parâmetros do Relatório"
        subtitle="Informe os dados para filtrar as informações do relatório."
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/***************************************** AVISOS **********************************/}
      <Box
        sx={{
          flexGrow: 1,
          padding: 3,
          display: "flex",
        }}
      >
        <form onSubmit={handleSubmit} style={{ width: "100%" }}>

          <Grid container spacing={2}>

            {formData.map((reg, index) => (

              < Grid item xs={12} key={index} >

                {(reg.tipo === "text" || reg.tipo === "number") && (

                  <TextField
                    fullWidth
                    label={reg.descricao}
                    variant="outlined"
                    value={reg.tipo === "number" ? (reg.valor ?? 0) : (reg.valor ?? "")}
                    onChange={handleChange}
                    name={reg.nome}
                    required
                    type={reg.tipo === "number" ? "number" : "text"}
                  />

                )}

                {(reg.tipo === "date") && (

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      fullWidth
                      format="DD/MM/YYYY"
                      sx={{ width: "100%" }}
                      label={reg.descricao}
                      value={
                        reg.valor
                          ? dayjs(reg.valor, "DD/MM/YYYY")
                          : null
                      }
                      onChange={(d) => handleDateChange(reg.nome, d)}
                      name={reg.nome}
                    />
                  </LocalizationProvider>

                )}

              </Grid>

            ))}

            <Grid
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 2,
              }}
            >
              {/* GRUPO DE BOTÕES DA ESQUERDA */}
              <Box sx={{ display: "flex", gap: 1 }}>
                <Button
                  variant="contained"
                  size="large"
                  sx={{ backgroundColor: "#1a3865", xs: 12, md: 4 }}
                  onClick={handleVoltar}
                >
                  Voltar
                </Button>
              </Box>

              <Button
                variant="contained"
                color="primary"
                size="large"
                sx={{
                  backgroundColor: "#1a3865",
                  marginLeft: 2,
                  xs: 12,
                  md: 8,
                }}
                type="submit"
              >
                IMPRIMIR
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box >
  );
};

export default RelatoriosImprimir;
